<template>
  <form @submit.prevent="handleSubmit" id="category_edit_form">

    <div v-if="loading" class="text-center py-4">
      <i class="fa fa-spinner fa-spin"></i> Loading category...
    </div>

    <div v-else>
      <div class="mb-4">
        <label class="form-label form-label-thin">Category Name <span class="text-danger">*</span></label>
        <input type="text" class="form-control form-control-thin" id="name" name="name" ref="name"
          v-model="form.name" placeholder="Category Name" />
        <div v-if="errors.name" class="text-danger small">{{ errors.name[0] }}</div>
      </div>

      <div class="mb-4">
        <label class="form-label form-label-thin">Description If Any</label>
        <textarea class="form-control form-control-thin" id="description" name="description" ref="description"
          v-model="form.description" placeholder="Category Description" rows="2"></textarea>
        <div v-if="errors.description" class="text-danger small">{{ errors.description[0] }}</div>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-sm btn-outline-secondary" @click="close">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary text-light hover-white btn-md form-submit-btn" 
        :disabled="submitting || loading">
        <i class="fa fa-save"></i> {{ submitting ? 'Saving...' : 'Save Changes' }}
      </button>
    </div>

  </form>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'

export default {
  name: 'EditCategory',
  emits: ['updated', 'close'],
  props: {
    categoryId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: {
        name: '',
        description: ''
      },
      errors: {},
      submitting: false,
      loading: false,
      categoryData: null
    }
  },
  mounted() {
    this.fetchCategory()
  },
  methods: {
    async fetchCategory() {
  this.loading = true
  
  const result = await form_api_submit({
    url: `asset/category/${this.categoryId}`,
    method: 'GET',
    data: {},
    show_success_toast: false,
    show_error_toast: true,
    remove_pre_toasts: false
  })

  if (result.success) {
    // The category is inside result.data.category
    const category = result.data.category || result.data
    this.categoryData = category
    this.form.name = category.name || ''
    this.form.description = category.description || ''
    
    // Debug log to verify
    console.log('Category data:', category)
    console.log('Form data:', this.form)
  }

  this.loading = false
},
    async handleSubmit() {
      this.submitting = true
      this.errors = {}

      const result = await form_api_submit({
        url: `asset/category/update/${this.categoryId}`,
        method: 'PUT',
        data: this.form,
        curr_form_id: '#category_edit_form',
        show_success_toast: true,
        show_error_toast: true
      })

      if (result.success) {
        this.$emit('updated')
        this.close()
      } else if (result.errors) {
        this.errors = result.errors
      }

      this.submitting = false
    },

    close() {
      this.$emit('close')
    }
  }
}
</script>